import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { AnswerLink } from '../../components/Step/AnswerLink';
import { STEP_LOGO } from '../constants';
import type { SelectedValues } from '../config';
import type { LogoValue } from './LogoStepInputs';

interface LogoStepAnswerProps {
    link: string;
    data: SelectedValues;
    onClick: () => void;
}

const answerCopy = (): Record<LogoValue, string> => ({
    'logo-required': __('need a logo'),
    'logo-not-required': __("don't need a logo"),
});

export function LogoStepAnswer({ data, link, onClick }: LogoStepAnswerProps) {
    const value = data[STEP_LOGO];
    const answer = value ? answerCopy()[value] : '';

    return (
        <FormattedMessage
            message={__('I {logo}.')}
            values={{
                logo: (
                    <AnswerLink href={link} onClick={onClick}>
                        {answer}
                    </AnswerLink>
                ),
            }}
        />
    );
}
